// Generated by GitHub Copilot
import React from "react";
import ReactDOM from "react-dom/client";
import { BrowserRouter } from "react-router-dom";
import App from "./App";
import "./index.css";

const rootElement = document.getElementById("root");
if (!rootElement) {
  throw new Error("Root element not found");
}

ReactDOM.createRoot(rootElement).render(
  <React.StrictMode>
    <BrowserRouter basename={import.meta.env.BASE_URL}>
      <App />
    </BrowserRouter>
  </React.StrictMode>
);

const loader = document.getElementById("app-loader");
if (loader) {
  loader.style.opacity = "0";
  loader.style.transition = "opacity 180ms ease";
  window.setTimeout(() => {
    loader.remove();
  }, 200);
}
